import { Organization } from '@/typings/backend';
import { UserRoles } from '@/utils/roles';

export type UserOrganization = {
  id: string;
  createdAt: string;
  organization: Organization;
  organizationId: string;
  role: UserRoles;
  userId: string;
};

export type User = {
  id: string;
  email: string;
  password?: string;
  phoneNumber?: string;
  apiTokenCreatedAt?: string;
  name: string;
  shortName?: string;
  superRole?: UserSuperRole | null;
  knowledgeAreas?: string | null;
  attendantAreas?: string | null;
  createdAt: string;
  organizations?: UserOrganization[];
  attendingVia?: string;
  attendedAt?: string;
  allowWhatsAppQuestions?: boolean;
  whatsAppQuestionsPrompt?: string;
  allowContactSharing: boolean;
  notificationTokensWeb: NotificationTokensWeb[];
  deletedAt?: string | null;
  lastAccessDayAt?: string;
  whatsAppProfile?: WhatsAppProfile;
  notifyAreas?: string;
  flags?: {
    notifyAllNewThread?: UserAttendingVia;
    notifyNewThreadUserEmail?: boolean;
    notifyNewThreadUserWhatsApp?: boolean;
    notifyNewThreadUserPush?: boolean;
    notifyAlertEmail?: boolean;
    notifyAlertWhatsApp?: boolean;
    notifyAlertPush?: boolean;
    myThreadColor?: UserThreadColor;
    notificationPlaySound?: boolean;
  };
};

export enum UserThreadColor {
  SKY_BLUE = 'sky-blue',
  MAGENTA = 'magenta',
  EMERALD = 'emerald',
  ELECTRIC_PURPLE = 'electric-purple',
}

export const USER_THREAD_COLOR_OPTIONS = {
  [UserThreadColor.SKY_BLUE]: { name: 'Azul Céu', value: 'sky-blue' },
  [UserThreadColor.MAGENTA]: { name: 'Magenta', value: 'magenta' },
  [UserThreadColor.EMERALD]: { name: 'Verde Esmeralda', value: 'emerald' },
  [UserThreadColor.ELECTRIC_PURPLE]: {
    name: 'Roxo Elétrico',
    value: 'electric-purple',
  },
} as const;

export enum UserAttendingVia {
  WEB_ADMIN = 'WEB_ADMIN',
  PERSONAL_WHATSAPP = 'PERSONAL_WHATSAPP',
}

export type NotificationTokensWeb = {
  token: string;
  userAgent: string;
  createdAt: string;
  deactivatedAt?: string;
  successCount: number;
  failCount: number;
  lastSuccessAt?: string;
  lastFailAt?: string;
  lastClientAckAt?: string;
};

export enum UserSuperRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  SUPPORT = 'SUPPORT',
}

export type WhatsAppProfile = {
  wuid: string;
  numberExists: boolean;
  picture: string;
  status: string;
  isBusiness: boolean;
};

// export type UserFlags {
//   notifyAllNewThread          UserAttendingVia?
// }
